import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ChevronDown, ChevronUp, Check, X } from 'lucide-react';
import SafeHTML from '../components/SafeHTML';
import { getFaqKey } from '../utils/keys';

const BaliVisaPage = () => {
  const { t } = useTranslation();
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    {
      question: t('baliFaq1Q'),
      answer: t('baliFaq1A')
    },
    {
      question: t('baliFaq2Q'),
      answer: t('baliFaq2A')
    },
    {
      question: t('baliFaq3Q'),
      answer: t('baliFaq3A')
    },
    {
      question: t('baliFaq4Q'),
      answer: t('baliFaq4A')
    },
    {
      question: t('baliFaq5Q'),
      answer: t('baliFaq5A')
    },
    {
      question: t('baliFaq6Q'),
      answer: t('baliFaq6A')
    }
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section 
        className="relative h-[500px] bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://static.prod-images.emergentagent.com/jobs/d25227ee-79aa-4fd4-96e0-b9726e9ae585/images/3d3a0703ce321e7e3a1dffab07dd5ac49c435ceb96e1dba09e2a7522c86fa85f.png)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
        <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
          <div className="max-w-2xl">
            <div className="inline-block bg-yellow-400 text-black px-4 py-2 rounded font-bold mb-4">
              {t('baliBadge')}
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              {t('baliHeroTitle')}
            </h1>
            <p className="text-xl text-white/90 mb-8">
              {t('baliHeroSubtitle')}
            </p>
            <a
              href="https://wa.me/971585862103?text=Hello%2C%20I%20would%20like%20to%20apply%20for%20a%20Bali%20Indonesia%20Visa"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gradient-to-r from-logo-blue to-logo-cyan text-white px-8 py-4 rounded-lg font-semibold text-lg hover:shadow-xl transition-all"
            >
              {t('baliHeroBtn')}
            </a>
          </div>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        <div className="prose prose-lg max-w-none mb-16">
          <SafeHTML tag="p" className="text-gray-700 text-lg leading-relaxed" html={t('baliIntro1')} />
          <SafeHTML tag="p" className="text-gray-700 text-lg leading-relaxed mt-4" html={t('baliIntro2')} />
        </div>

        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">{t('baliProcessTitle')}</h2>
          
          <div className="space-y-8">
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-logo-blue rounded-full flex items-center justify-center text-white text-2xl font-bold">1</div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{t('baliProcess1Title')}</h3>
                <p className="text-gray-600">{t('baliProcess1Desc')}</p>
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-logo-blue rounded-full flex items-center justify-center text-white text-2xl font-bold">2</div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{t('baliProcess2Title')}</h3>
                <p className="text-gray-600">{t('baliProcess2Desc')}</p>
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-logo-blue rounded-full flex items-center justify-center text-white text-2xl font-bold">3</div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{t('baliProcess3Title')}</h3>
                <p className="text-gray-600">{t('baliProcess3Desc')}</p>
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-logo-blue rounded-full flex items-center justify-center text-white text-2xl font-bold">4</div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{t('baliProcess4Title')}</h3>
                <p className="text-gray-600">{t('baliProcess4Desc')}</p>
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-logo-blue rounded-full flex items-center justify-center text-white text-2xl font-bold">5</div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{t('baliProcess5Title')}</h3>
                <p className="text-gray-600">{t('baliProcess5Desc')}</p>
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-logo-blue rounded-full flex items-center justify-center text-white text-2xl font-bold">6</div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{t('baliProcess6Title')}</h3>
                <p className="text-gray-600">{t('baliProcess6Desc')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">{t('baliDocumentsTitle')}</h3>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>{t('baliDoc1')}</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>{t('baliDoc2')}</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>{t('baliDoc3')}</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>{t('baliDoc4')}</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>{t('baliDoc5')}</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>{t('baliDoc6')}</span>
            </li>
          </ul>
        </div>

        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">{t('baliFaqTitle')}</h3>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={getFaqKey(faq.question, index)} className="border border-gray-200 rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between p-4 text-left bg-white hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                  {openFaq === index ? (
                    <ChevronUp className="w-5 h-5 text-logo-blue flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-logo-blue flex-shrink-0" />
                  )}
                </button>
                {openFaq === index && (
                  <div className="px-4 pb-4 bg-gray-50">
                    <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t('baliPackagesTitle')}</h2>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-4 text-left font-bold text-gray-900">{t('saTableFeatures')}</th>
                  <th className="border border-gray-300 p-4 text-center font-bold text-gray-900">
                    <div>{t('baliTableCol1')}</div>
                    <div className="text-sm font-normal text-gray-600">{t('baliTableCol1Time')}</div>
                  </th>
                  <th className="border border-gray-300 p-4 text-center font-bold text-gray-900 bg-blue-50">
                    <div>{t('baliTableCol2')}</div>
                    <div className="text-sm font-normal text-gray-600">{t('baliTableCol2Time')}</div>
                  </th>
                  <th className="border border-gray-300 p-4 text-center font-bold text-gray-900">
                    <div>{t('saTablePremium')}</div>
                    <div className="text-sm font-normal text-gray-600">{t('baliTableCol3Time')}</div>
                  </th>
                  <th className="border border-gray-300 p-4 text-center font-bold text-gray-900">
                    <div>{t('saTableVip')}</div>
                    <div className="text-sm font-normal text-gray-600">{t('baliTableCol4Time')}</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-3 text-gray-700">{t('baliFeature1')}</td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center bg-blue-50"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 p-3 text-gray-700">{t('baliFeature2')}</td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center bg-blue-50"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-3 text-gray-700">{t('baliFeature3')}</td>
                  <td className="border border-gray-300 p-3 text-center"><X className="w-5 h-5 text-gray-400 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center bg-blue-50"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 p-3 text-gray-700">{t('baliFeature4')}</td>
                  <td className="border border-gray-300 p-3 text-center"><X className="w-5 h-5 text-gray-400 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center bg-blue-50"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-3 text-gray-700">{t('baliFeature5')}</td>
                  <td className="border border-gray-300 p-3 text-center"><X className="w-5 h-5 text-gray-400 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center bg-blue-50"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 p-3 text-gray-700">{t('baliFeature6')}</td>
                  <td className="border border-gray-300 p-3 text-center"><X className="w-5 h-5 text-gray-400 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center bg-blue-50"><X className="w-5 h-5 text-gray-400 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-3 text-gray-700">{t('baliFeature7')}</td>
                  <td className="border border-gray-300 p-3 text-center"><X className="w-5 h-5 text-gray-400 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center bg-blue-50"><X className="w-5 h-5 text-gray-400 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="border border-gray-300 p-3 text-gray-700">{t('baliFeature8')}</td>
                  <td className="border border-gray-300 p-3 text-center"><X className="w-5 h-5 text-gray-400 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center bg-blue-50"><X className="w-5 h-5 text-gray-400 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><X className="w-5 h-5 text-gray-400 mx-auto" /></td>
                  <td className="border border-gray-300 p-3 text-center"><Check className="w-5 h-5 text-green-600 mx-auto" /></td>
                </tr>
                <tr>
                  <td className="border border-gray-300 p-4"></td>
                  <td className="border border-gray-300 p-4 text-center">
                    <a href="https://wa.me/971585862103?text=I%20want%20VoA%20Bali%20guidance" target="_blank" rel="noopener noreferrer" className="inline-block bg-gray-200 hover:bg-gray-300 text-gray-900 px-6 py-2 rounded font-semibold transition-colors">{t('saGetInTouch')}</a>
                  </td>
                  <td className="border border-gray-300 p-4 text-center bg-blue-50">
                    <a href="https://wa.me/971585862103?text=I%20want%20B211A%20Bali%20Visa" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-r from-logo-blue to-logo-cyan hover:shadow-lg text-white px-6 py-2 rounded font-semibold transition-all">{t('saGetInTouch')}</a>
                  </td>
                  <td className="border border-gray-300 p-4 text-center">
                    <a href="https://wa.me/971585862103?text=I%20want%20Premium%20Bali%20Visa" target="_blank" rel="noopener noreferrer" className="inline-block bg-gray-200 hover:bg-gray-300 text-gray-900 px-6 py-2 rounded font-semibold transition-colors">{t('saGetInTouch')}</a>
                  </td>
                  <td className="border border-gray-300 p-4 text-center">
                    <a href="https://wa.me/971585862103?text=I%20want%20VIP%20Bali%20Visa" target="_blank" rel="noopener noreferrer" className="inline-block bg-gray-200 hover:bg-gray-300 text-gray-900 px-6 py-2 rounded font-semibold transition-colors">{t('saGetInTouch')}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

      <Footer />
    </div>
  );
};

export default BaliVisaPage;
